import { LOADING_STATUS } from 'client/js/main/support/constants';
import { INIT_STATE } from 'client/js/redux/domains/FileIngestor/FileIngestor.constants';
import type { FileIngestorState } from 'client/js/redux/domains/FileIngestor/FileIngestor.types';
import type { FileIngestorAction } from 'client/js/redux/domains/FileIngestor/actions';
import { GET_JOBS, GET_JOB_BY_ID, TRIGGER_JOB, UPLOAD_FILE } from 'client/js/redux/domains/FileIngestor/actions';
import { CLEAR_JOB_DETAILS } from 'client/js/redux/domains/FileIngestor/actions/clearJobDetails';
import { QUICK_VALIDATE } from 'client/js/redux/domains/FileIngestor/actions/quickValidate.action';
import { ReduxAsyncActionsService } from 'client/js/redux/services/ReduxAsyncActions.service';
import type { WrappedReducer } from 'client/js/redux/types/ReduxAsyncActions.types';

const Handler = (
  state: WrappedReducer<FileIngestorState>,
  action: FileIngestorAction
): WrappedReducer<FileIngestorState> => {
  switch (action.type) {
    case TRIGGER_JOB.response:
      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
      };
    case UPLOAD_FILE.response:
      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
        fileUri: action.data.fileUri,
      };
    case GET_JOBS.response:
      const jobs = action.data.data || [];
      const pagination = action.data.pagination || {
        sort: {
          field: 'updated',
          order: 'DESC',
        },
        results_per_page: 10,
        total: 0,
      };

      return {
        ...state,
        loading: false,
        jobs,
        pagination,
      };
    case GET_JOB_BY_ID.response:
      return {
        ...state,
        jobDetails: action.data,
      };
    case CLEAR_JOB_DETAILS:
      return { ...state, jobDetails: null };
    case QUICK_VALIDATE.response:
      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
      };
    default:
      return state;
  }
};

const FileIngestorReducer = ReduxAsyncActionsService.wrapReducer(INIT_STATE, Handler, {
  request: [TRIGGER_JOB, UPLOAD_FILE, GET_JOBS, QUICK_VALIDATE],
  error: [TRIGGER_JOB, UPLOAD_FILE, GET_JOBS, QUICK_VALIDATE],
});

export default FileIngestorReducer;
